var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "modalFooter", staticClass: "room-upgrade-modal-footer" },
    [
      _c("div", { staticClass: "room-upgrade-modal-footer-left" }, [
        _c("div", { staticClass: "room-upgrade-modal-footer-price" }, [
          _c("span", { staticClass: "total" }, [
            _vm._v(_vm._s(_vm.tc("booking.total"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.formatPrice(_vm.currentCartTotal))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "left-cta--large",
            class: {
              loading: _vm.roomUpgradeLoading,
              "upgrade-selected": _vm.roomUpgradeSelected,
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.handleLeftCtaClick($event)
              },
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.handleLeftCtaClick($event)
              },
            },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.roomUpgradeSelected
                    ? _vm.tc("booking.removeUpgrade")
                    : _vm.tc("booking.continueLabel")
                ) +
                "\n      "
            ),
            _c("div", { staticClass: "sr-only", attrs: { role: "status" } }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.roomUpgradeLoading
                      ? _vm.tc("accessibility.loadingButtonStatus")
                      : ""
                  ) +
                  "\n      "
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "room-upgrade-modal-footer-right" }, [
        _c("div", { staticClass: "room-upgrade-modal-footer-price" }, [
          _c("span", { staticClass: "total" }, [
            _vm._v(_vm._s(_vm.tc("booking.total"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.formatPrice(_vm.upgradeRoomCartTotal))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "right-cta--large",
            class: {
              loading: _vm.roomUpgradeLoading,
              "upgrade-selected": _vm.roomUpgradeSelected,
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.handleRightCtaClick($event)
              },
            },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.roomUpgradeSelected
                    ? _vm.tc("booking.continueLabel")
                    : _vm.tc("booking.upgrade")
                ) +
                "\n      "
            ),
            _c("div", { staticClass: "sr-only", attrs: { role: "status" } }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.roomUpgradeLoading
                      ? _vm.tc("accessibility.loadingButtonStatus")
                      : ""
                  ) +
                  "\n      "
              ),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }